import getURLCodigoQR from "@components/general/GenerarQR/getURLCodigoQR/getURLCodigoQR";
import TitleDashboard from "@components/general/Titles/TitleDashboard";
import UserContext from "@context/User/UserContext";
import useWindowResize from "@customHooks/useWindowResize";
import { faDownload, faPlus, faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import getFechaSinHora from "@helpers/dates/getDateFinalizacionCurso/getFechaSinHora";
import getUnixTimestamp from "@helpers/dates/getUnixTimestamp/getUnixTimestamp";
import { getFechaFinalizacionCurso, guardarCertificado } from "@helpers/httpRequests/httpRequestsCertificadosEmitidos/httpRequestsCertificadosEmitidos";
import { getCursos } from "@helpers/httpRequests/httpRequestsCursos/httpRequestsCursos";
import { addCurso, verificarCursoUsuario } from "@helpers/httpRequests/httpRequestsCursosUsuario/httpRequestsCursosUsuario";
import multiViewComponentsPaths from "@helpers/multiViewComponentsPaths/multiViewComponentsPaths";
import spanishOptionsJoyRide from "@helpers/spanishOptionsJoyRide/spanishOptionsJoyRide";
import confetti from "canvas-confetti";
import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useContext } from "react";
import { Animated } from "react-animated-css";
import { Accordion, Alert, Button, Card, Col, Container, Image, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import Joyride from "react-joyride";
import QRCode from "qrcode";



import { Carousel as ReactCarousel } from "react-responsive-carousel";
import { NotificacionExtendida } from "@components/general/Alertas/Alertas";
import getFilledPdfBytes from "@components/general/GenerarQR/getFilledPdfBytes/getFilledPdfBytes";
import ListadoCursosLecturaVeloz from "@components/general/Cursos/ListadoCursosLecturaVeloz";
import { validarHayConvenio } from "@helpers/httpRequests/httpRequestConvenios/httpRequestConvenios";
import { obtenerEstadisticasEstudiante, recuperarExamenDiagnostico, validateExamenRealizado } from "@helpers/httpRequests/httpRequestsGruposLectura/httpRequestsGruposLectura";
import FormExamenDiagnostico from "../components/FormExamenDiagnostico";
import { Star, Warning } from "@mui/icons-material";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import dashboardRoutesPaths from "@helpers/dashboardRoutesPaths/dashboardRoutesPaths";

const createData = (semana, ppm, comprension) => {
  return { semana, ppm, comprension};
}

const rows = [
  createData(1, 365, 70),
  createData(2, 430, 70),
  createData(3, 495, 75),
  createData(4, 560, 75),
  createData(5, 630, 80),
  createData(6, 700, 80),
  createData(7, 770, 85),
  createData(8, 850, 85),
  createData(9, 930, 90),
  createData(10, 1010, 90),
  createData(11, 1080, 95),
  createData(12, 1140, 95),
  createData(13, 1180, 100),
  createData(14, 1200, 100),
  
];

const HomeLecturaVeloz = ({
  showScrollButton,
  handleChangeComponent,
  handleScrollToTop,
}) => {
  const { contextValue, setContextValue } = useContext(UserContext);

  const [cursos, setCursos] = useState([]);

  const { usuarioLogeado } = contextValue;

  const { nombreCompleto, apellidos, idPerfil, correo, rol, idUsuarioEmpresarial, curp, codigoInstitucion, folioContrato, nombreLicencia } = usuarioLogeado;

  const [runTour, setRunTour] = useState(false);

  const [palabrasMinuto, setPalabrasMinuto] = useState('440');
  
  const [puntajeComprension, setPuntajeComprension] = useState(0);

  const joyrideRef = useRef(null);

  const [dataImage, setDataImage] = useState({
    dataImage: "",
  });

  const [tourSteps, setTourSteps] = useState([

    {
      target: ".container-lv",
      content: "Te damos la bienvenida a Click+, completa tu curso de lectura veloz y no pierdas la oportunidad de ir más alla en tu aprendizaje al conocer los demás cursos que la plataforma tiene para tí.",
      disableBeacon: true,
    },


  ]);

  const [certificacionLectura, setCertificacionLectura] = useState(false);

  const [usuarioConConvenio, setUsuarioConConvenio]= useState(false);

  const [semanaAvance, setSemanaAvance] = useState(1);

  const [diagnosticoHabilitado, setDiagnosticohabilitado] = useState(false);

  const [codigoExamenDiagnostico, setCodigoExamenDiagnostico] = useState('');

  const {
    size: { width },
  } = useWindowResize();

  const slides = [
    {
      image: (
        <div className="image-wrapper m-auto">
          <picture>
            <source
              srcSet={`${require("@assets/images/recursos_mos/logo_excel.png")}`}
            />
            <Image
              className="imageMos mt-3"
              src={`${require("@assets/images/recursos_mos/logo_excel.png")}`}
              alt="Imagen de slide"
            />
          </picture>
        </div>
      ),
      title: <h2 className="my-2">Certificacación MOS</h2>,
      subtitle: (
        <h5 className="mx-5 px-5">
          Prepárate para tu Certificado Microsoft Office Specialist, te ayudará
          a mejorar tu análisis de datos, la toma de decisiones y optimización
          de procesos, además de destacar para mejores puestos y oportunidades
          laborales.
        </h5>
      ),
      control: (
        <Button
          onClick={() => {
            handleChangeComponent(
              multiViewComponentsPaths.solicitudLlamadaVenta
            );
          }}
          className="mt-2"
        >
          Haz clic aquí para tener acceso a la Certificación MOS
        </Button>
      ),
    },
    {
      image: (
        <picture>
          <source
            srcSet={`${require("@assets/images/recursos_mos/reseña_mos.webp")}`}
          />
          <source
            srcSet={`${require("@assets/images/recursos_mos/reseña_mos.png")}`}
          />
          <Image
            width="100%"
            height="30%"
            loading="lazy"
            className="comentario-mos"
            src={`${require("@assets/images/recursos_mos/reseña_mos.webp")}`}
            alt="Imagen de slide"
          />
        </picture>
      ),
    },
    {
      image: (
        <picture>
          <source
            srcSet={`${require("@assets/images/recursos_mos/reseña_mos2.webp")}`}
          />
          <source
            srcSet={`${require("@assets/images/recursos_mos/reseña_mos2.png")}`}
          />
          <Image
            width="100%"
            height="30%"
            loading="lazy"
            className="comentario-mos"
            src={`${require("@assets/images/recursos_mos/reseña_mos2.webp")}`}
            alt="Imagen de slide"
          />
        </picture>
      ),
    },
    {
      image: (
        <picture>
          <source
            srcSet={`${require("@assets/images/recursos_mos/reseña_mos3.webp")}`}
          />
          <source
            srcSet={`${require("@assets/images/recursos_mos/reseña_mos3.png")}`}
          />
          <Image
            width="100%"
            height="30%"
            loading="lazy"
            className="comentario-mos"
            src={`${require("@assets/images/recursos_mos/reseña_mos3.webp")}`}
            alt="Imagen de slide"
          />
        </picture>
      ),
    },
  ];

  const handleStartTour = async () => {
    console.log('Comienza el tour')
    setRunTour(true);
  };

  const handlePagar = () => {
    handleChangeComponent('solicitudLlamadaVenta');
  }


  const generarCertificado = async() =>{
    var end = Date.now() + 15 * 250;

    // go Buckeyes!
    var colors = ["#00152A", "#ff9900"];

    (function frame() {
      confetti({
        particleCount: 2,
        angle: 60,
        spread: 35,
        origin: { x: 0 },
        colors: colors,
      });
      confetti({
        particleCount: 2,
        angle: 120,
        spread: 35,
        origin: { x: 1 },
        colors: colors,
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
    try {
      const infoCertificado = {
        rol: rol,
        idUsuarioEmpresarial: idUsuarioEmpresarial,
        idPerfil,
        codigoCurso: "LV23",
        nombre: nombreCompleto,
        curp,
        fecha: getUnixTimestamp(),
        nombreCurso: "Lectura Inteligente",
      };

      const { data } = await guardarCertificado(infoCertificado);

      const { data: fechaFinalizacion } = await getFechaFinalizacionCurso({
        idPerfil,
        codigoCurso: "LV23",
      });

      const resultados = `Con un promedio de ${palabrasMinuto} palabras por minuto y una comprensión lectora del ${puntajeComprension} por ciento`;


      let payloadCodigoQR = {
        fechaFinalizacion: getFechaSinHora(fechaFinalizacion.fecha),
        fechaUnix: fechaFinalizacion.fecha,
        nombre: nombreCompleto + " " + apellidos,
        nombreCurso: `Lectura Inteligente`,
        tiempoCurso: "14",
        idPerfil,
        codigoCurso: "LV23",
        curso: false,
        resultados: resultados.toString()
      };

      //TODO Hacer debug para encontrar el porque no pasa correctamente la informacion para generar el qr

      const urlQR = getURLCodigoQR(payloadCodigoQR);

      const qrData = await QRCode.toDataURL(urlQR);

      payloadCodigoQR.dataQR = qrData;

      await createPdf(payloadCodigoQR);
    } catch (error) {
      console.log(error);
    }
  }

  const createPdf = async (dataCodigoQR) => {
    try {
      let templateURL = '';
      switch (codigoInstitucion) {
        case 'GCMX':
          templateURL = 'assets/templates/Certificado de participacion - Lectura Inteligente.pdf';
          break;
        
        case 'UVEG':
          templateURL = 'assets/templates/Certificado de participacion - Lectura Inteligente.pdf';
          break;
      
        default:
          break;
      }

      let url = `${window.location.origin}/${templateURL}`;

      const data = await fetch(url);

      const pdfTemplateBytes = await data.arrayBuffer();

      const filledPdfBytes = await getFilledPdfBytes(
        pdfTemplateBytes,
        dataCodigoQR
      );

      saveByteArray(`Certificado - Lectura Veloz`, filledPdfBytes);
    } catch (error) {
      console.log(error);
    }
  };

  //Funcion para descargar el pdf sin la libreria
  const saveByteArray = (reportName, byte) => {
    var blob = new Blob([byte], { type: "application/pdf" });

    var link = document.createElement("a");

    link.href = window.URL.createObjectURL(blob);

    var fileName = reportName;

    setDataImage({
      ...dataImage,
      dataImage: link.href,
    });

    link.download = fileName;

    link.click();

    NotificacionExtendida("success", "Certificado generado con éxito");
  };

  const [infoExamenDiagnostico, setInforExamenDiagnostico] = useState([]);
  const [realizarExamenDiagnostico, setRealizarExamenDiagnostico] = useState(false);

  const handleExamenDiagnostico = async() => {
    setRealizarExamenDiagnostico(true);
    handleScrollToTop();
  }

  const [adminForo, setAdminForo] = useState(false);

  const obtenerUltimoEjercicio= (codigo) => {
        let infoUsuario = {};

        if(codigo === 'Sin avance'){
          infoUsuario.semana = 1;
          return infoUsuario;
        }
      
        const semana = parseInt(codigo.slice(0, 2), 10);
        // const dia = parseInt(codigo.slice(2, 4), 10);
        // const sesion = parseInt(codigo.slice(4, 7), 10);
        // const ejercicio = parseInt(codigo.slice(7, 9), 10);

        infoUsuario.semana = semana;


        return infoUsuario;
    }

    const validarExamenResuelto = (codigoExamen, infoEvaluacion)=>{
      return new Promise(async(resolve, reject)=>{
        try{
          const verificacion = await validateExamenRealizado({idPerfil, codigoExamen });
          
          resolve(true);
        }catch(error){
          setInforExamenDiagnostico([infoEvaluacion]);
          setDiagnosticohabilitado(true);
          reject(false);
        }
      })
    }

    const participarCompetencia = ()=> {
      window.location.replace(dashboardRoutesPaths.lectura.pruebas.pruebaCompetencias);
    }

  useEffect(() => {

     const getEstadisticasUsuario = async() => {
      try {
          console.log('Correo Usuario: ', correo);
          const estadisticas = await obtenerEstadisticasEstudiante({ correo });
          console.log(estadisticas);

          const infoSemanaAvance = obtenerUltimoEjercicio(estadisticas.avancePersonal.ultimoEjercicio);

          console.log(infoSemanaAvance);

          setSemanaAvance(infoSemanaAvance.semana);

      } catch (error) {
        console.log('Error al obtener el avance del usuario: ', error);
      }
    }

    const obtenerExamenDiagnostico = async() =>{
      try{
        //Recuperar el examen diagnostico habilitado mas reciente para que se muestre la info aqui.
        const {data: resultados} = await recuperarExamenDiagnostico();

        const {data} = resultados;

        setCodigoExamenDiagnostico(data.codigoExamen);

        //En caso de que ya se tenga el examen resuelto, hay que verificarlo con el codigo del examen y el perfil del usuario.
        
        const evaluacionRealizada = await validarExamenResuelto(data.codigoExamen);

        console.log("EVALUACION REALIZADA:", evaluacionRealizada);
        

      }catch(error){
        console.log("Error al recuperar el examen de diagnostico: ", error);
      }
    }

    //Se reciben los datos para manejarlos en la vista pública
    const param = new URLSearchParams(window.location.search);

    const datosURL = param.get("email");

    const palabras = param.get("ppm");

    if(palabras !== null) {
      setPalabrasMinuto(palabras);
    }

    const comprension = Math.floor(Math.random() * (97 - 86) + 86);

    setPuntajeComprension(comprension);
    
    //Transformamos el string del data en arreglo
    console.log(datosURL);

    if (datosURL !== null) {
      //Guardar registro en certificados emitidos

      const guardarCursoLectura = async () => {
        try {
          const infoCurso = {
            rol: 'estudiante',
            codigoCurso: "LV23",
            idPerfil,
            idUltimaLeccionTomada: "LV230101",
            puntajeEvaluacion: comprension,
          };


          await addCurso(infoCurso);

        } catch (error) {
          console.log(error);
        }
      }
      guardarCursoLectura()

    }


    const consultarCursos = async () => {
      try {
        let { data: cursos } = await getCursos();

        if (!Array.isArray(cursos)) {
          cursos = [cursos];
        }

        setCursos(cursos);
      } catch (error) {
        console.log("Error al consultar los cursos: ", error);
      }
    };

    consultarCursos();

    const validarConvenio = async() => {
          if(rol === 'asesor_lectura'){
            setUsuarioConConvenio(true);
            return;
          }

          try {
            const results= await validarHayConvenio(folioContrato);
  
            // console.log("El folio tiene convenio con la uveg");
            setUsuarioConConvenio(true);
            getEstadisticasUsuario();
            if(semanaAvance > 1){

              obtenerExamenDiagnostico();
            }
            

          } catch (error) {
            console.log("Error al validar el convenio");
          }
        }
  
        validarConvenio();


   


  }, []);

  useEffect(() => {
    const consultarCertificacion = async () => {
      try {
        const infoCurso = {
          codigoCurso: 'LV23',
          idPerfil
        }
        const {data} = await verificarCursoUsuario(infoCurso);

        const {puntajeCertificacion} = data.data;

        setPuntajeComprension(puntajeCertificacion);
        setCertificacionLectura(true);
      } catch (error) {
        console.log(error);
      }
    }
    consultarCertificacion();
  }, [cursos])


  useEffect(() => {
    if (semanaAvance > 1) {
      const obtenerExamenDiagnostico = async () => {
        try {
          //Recuperar el examen diagnostico habilitado mas reciente para que se muestre la info aqui.
          const { data: resultados } = await recuperarExamenDiagnostico();

          const { data } = resultados;

          setCodigoExamenDiagnostico(data.codigoExamen);

          //En caso de que ya se tenga el examen resuelto, hay que verificarlo con el codigo del examen y el perfil del usuario.

          const evaluacionRealizada = await validarExamenResuelto(data.codigoExamen);

          console.log("EVALUACION REALIZADA:", evaluacionRealizada);


        } catch (error) {
          console.log("Error al recuperar el examen de diagnostico: ", error);
        }
      }
      obtenerExamenDiagnostico();
    }

  }, [semanaAvance]);

  const hoy = getUnixTimestamp();


  return (
    <Animated
      animationIn="fadeIn"
      animationInDuration={250}
      animationOut="fadeOut"
      isVisible={true}
    >
      <Container fluid className="p-0 container-lv">

        <Joyride
          locale={spanishOptionsJoyRide}
          ref={joyrideRef}
          steps={tourSteps}
          run={runTour}
          hideCloseButton
          showSkipButton
          continuous={true}
          disableOverlayClose={false}
          disableCloseOnEsc={false}
          disableScrolling={false}
          scrollToFirstStep={true}
          scrollOffset={100}
          callback={(data) => {
            if (data.status === "finished" || data.status === "skipped") {
              setRunTour(false);
            }
          }}
          styles={{
            options: {
              primaryColor: "#ff9900",
              textColor: "#00152A",
              width: 900,
              zIndex: 1000,
            },
          }}
        />

        {realizarExamenDiagnostico ? (
          <FormExamenDiagnostico codigoExamenDiagnostico={codigoExamenDiagnostico} usuarioLogeado={usuarioLogeado} handleScrollToTop={handleScrollToTop} semanaAvance={semanaAvance} setRealizarExamenDiagnostico={setRealizarExamenDiagnostico} />
        ) : (
          <>

            {hoy < 1776628580 ? (
              <Row className="mt-4 mx-2 mb-5">
                <Col className="text-center">
                  {/* <span style={{ fontSize: "1.8rem", color: '#fff' }}>
                ¡Hola {nombreCompleto}! Te damos la bienvenida
              </span> */}
                  <Image className={`${(usuarioConConvenio || nombreLicencia === 'Lectura Inteligente - UVEG') ? 'pointer' : ''}`} onClick={(usuarioConConvenio || nombreLicencia === 'Lectura Inteligente - UVEG') ? participarCompetencia : () => {} } src={(usuarioConConvenio || nombreLicencia === 'Lectura Inteligente - UVEG') ? require("@assets/images/setupBannerLectura.png") : require("@assets/images/bannerLectura.webp")} style={{ width: "100%", borderRadius: "15px" }} />
                </Col>
              </Row>
            ): (
              <Row className="mt-4 mx-2 mb-5">
                <Col className="text-center">
                  
                  <Image src={(usuarioConConvenio || nombreLicencia === 'Lectura Inteligente - UVEG') ? require("@assets/images/bannerUveg.webp") : require("@assets/images/bannerLectura.webp")} style={{ width: "100%", borderRadius: "15px" }} />
                </Col>
              </Row>

            )}

            

            {/* <Row className="justify-content-end mt-4 mb-4">
          {width >= 1024 && (
            <Col className="col-md-2 mb-4 " style={{ height: "0px" }}>
              <OverlayTrigger placement={"top"} overlay={<Tooltip>Conoce tu entorno</Tooltip>}>
                <span>
                  <FontAwesomeIcon className="mx-5 pointer question" onClick={handleStartTour} style={{ fontSize: "2.2rem" }} icon={faQuestion} />
                </span>
              </OverlayTrigger>
            </Col>
          )}
        </Row> */}
            {/* {certificacionLectura ? (
          <Row className="mb-4 mt-3 justify-content-center">

            <Col className="text-center col-12 col-lg-6 shadow" style={{borderRadius: "15px", backgroundColor: "#e2e2e2"}}>
              <script src="https://cdn.lordicon.com/lordicon.js"></script>
              <lord-icon
                src="https://cdn.lordicon.com/fkmafinl.json"
                trigger="loop"
                delay="2000"
                style={{width: "100px", height: "100px", marginTop: "20px"}}>
              </lord-icon>
              <h3>Has completado el curso de lectura veloz, ya puedes descargar tu certificado</h3>
              <Button onClick={generarCertificado} className="btn btn-success mt-2 mb-5">Descargar <FontAwesomeIcon icon={faDownload}/></Button>
            </Col>
          </Row>
        ) : null} */}

            <Row className="justify-content-center text-center mb-5 mt-4">
                    <h2 class="text-center">2da convocatoria de Lectura Inteligente</h2>
                    <p>Mira como puedes participar en la dinámica</p>
                    <Col className="col-12 col-lg-6">

                      <div style={{ padding: "56.25% 0 0 0", position: "relative" }}><iframe src="https://player.vimeo.com/video/1177074340?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }} title="docentes"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
                     <video className="pt-4 h-100 w-100" controls>
                                    <source src="https://globalclickmexico.com/img/ClicksitoPlus.mp4" type="video/mp4" />
                                  </video> 

                  
                    </Col>

              </Row>

            {usuarioLogeado.rol === 'asesor_lectura' && (
              <Row className="justify-content-center mb-5 mt-4">
                <h2 class="text-center">Seguimiento a los alumnos</h2>
                <Col className="col-12 col-lg-6">

                  <div style={{ padding: "56.25% 0 0 0", position: "relative" }}><iframe src="https://player.vimeo.com/video/1136998955?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }} title="docentes"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>


                  {/* <video className="pt-4 h-100 w-100" controls>
              <source src="https://globalclickmexico.com/img/ClicksitoPlus.mp4" type="video/mp4" />
            </video> */}
                </Col>

              </Row>
            )}

            {(infoExamenDiagnostico.length > 0 && diagnosticoHabilitado) ? (
              <Row className="justify-content-center">
                <Col lg={10}>
                  <Alert variant='warning text-center'>
                    <p className="text-warning"><Warning fontSize="large" /></p>
                    <b>Hay una evaluación diagnóstica pendiente, por favor realízala antes de continuar con tu aprendizaje.</b>
                    <p><div>
                      <Button onClick={handleExamenDiagnostico} className="mt-3">Comenzar evaluación</Button>
                    </div></p>
                  </Alert>
                </Col>
              </Row>
            ) : null}

            

            <Row className="justify-content-center mb-4 mt-4">
              <Col className="col-12 col-lg-6">
                <h2 class="text-center">Introducción</h2>

                <div style={{ padding: "56.25% 0 0 0", position: "relative" }}><iframe src="https://player.vimeo.com/video/1136137377?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }} title="Introducción"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>


                {!diagnosticoHabilitado ? (
                  <Row className="justify-content-center mb-4 mt-4">
                    <Col className="col-6 text-center gap-2 d-grid">
                      <a className="btn btn-warning" style={{ fontWeight: 'bold' }} href={`https://virtual.globalclickmexico.com/lectura_2/initCurso.php?nombreUsuario=${correo}${usuarioConConvenio ? `&folioContrato=${folioContrato}&semanaAvance=${semanaAvance}` : ''}`} target="_self">Ir al curso</a>
                    </Col>
                  </Row>
                ): null}

                {/* <video className="pt-4 h-100 w-100" controls>
              <source src="https://globalclickmexico.com/img/ClicksitoPlus.mp4" type="video/mp4" />
            </video> */}
              </Col>
              {usuarioConConvenio ? (

              <Col className="col-12 col-lg-6 mt-4 mt-log-0">
                <h4>Avisos y notificaciones</h4>
                {certificacionLectura ? (
                  <Row className="mb-3 mt-3 justify-content-center">

                    <Col className="text-start col-12 col-lg-6  w-100">

                      <Alert variant='success'>
                        ¡Has completado el curso de lectura veloz, ya puedes descargar <span className="text-primary pointer" onClick={generarCertificado}>aquí</span> tu certificado!
                      </Alert>
                      {/* Aviso para la evaluacion de diagnostico de corte */}

                    </Col>
                  </Row>
                ) : null}

                {/* Validar si hay un examen de disgnostico para mostrar en el home de lectura de estudiantes */}
                {/* {(infoExamenDiagnostico.length > 0 && semanaAvance > 1) ? ( */}
                {(infoExamenDiagnostico.length > 0) ? (
                  <Row className="mb-3 mt-3 justify-content-center">

                    <Col className="text-start col-12 col-lg-6  w-100">


                      <Alert variant='info'>
                        <b>Es momento de revisar tu progreso, realiza la siguiente evaluación para determinar tu progreso y niveles correctos.</b>
                        <div>
                          <Button onClick={handleExamenDiagnostico} className="mt-3">Comenzar</Button>
                        </div>
                      </Alert>

                      {/* Aviso para la evaluacion de diagnostico de corte */}

                    </Col>
                  </Row>
                ) : null}


                {/* {(infoExamenDiagnostico.length === 0 && !certificacionLectura || semanaAvance === 1) ? ( */}
                {infoExamenDiagnostico.length === 0 ? (
                  <Row className="mb-3 mt-3 justify-content-center">

                    <Col className="text-start col-12 col-lg-6  w-100">


                      <Alert variant='dark'>
                        Sin avisos por el momento.
                      </Alert>

                      {/* Aviso para la evaluacion de diagnostico de corte */}

                    </Col>
                  </Row>
                ) : null}

                    <Row className="justify-content-center mb-4 mt-4 ">

                      <Col className="col-12 text-center ">
                        <h5 style={{ fontWeight: 'bold' }}>Nuestros alumnos en promedio tienen el siguiente número de palabras por minuto y comprensión durante las 14 semanas de duración del curso</h5>
                        <TableContainer sx={{
                            maxHeight: 300,   // altura visible
                            overflow: "auto",
                            marginTop: '30px'
                        }} component={Paper}> 
                          <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                              <TableRow sx={{ backgroundColor: "#00152a" }}>
                                <TableCell style={{ color: "#fff", fontWeight: 'bold' }}>Semana del curso</TableCell>
                                <TableCell style={{ color: "#fff", fontWeight: 'bold' }} align="right">Palabras por minuto (ppm)</TableCell>
                                <TableCell style={{ color: "#fff", fontWeight: 'bold' }} align="right">Comprensión lectora (%)</TableCell>
                                {/* <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                          <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {rows.map((row, index) => (
                                <TableRow
                                  key={row.semana}
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: index % 2 === 0 ? "grey.100" : "white" }}
                                >
                                  <TableCell component="th" scope="row">
                                    {row.semana}
                                  </TableCell>
                                  <TableCell align="center">{row.ppm}</TableCell>
                                  <TableCell align="center">{row.comprension}%</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Col>
                    </Row>
              </Col>
              ): null}

              

            </Row>



            <Row className="justify-content-center my-5">


               <Col className="col-12 text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="175" height="175" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-devices" style={{ color: 'gray' }}><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M13 9a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-10z" /><path d="M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9" /><path d="M16 9h2" /></svg>
                </Col>
              <Col className="col-10 text-center">
               
                <h4 style={{ color: "gray" }}>Recomendamos realizar el curso en dispositivos de escritorio o portátiles como laptop o tablet para una mejor experiencia y mayor efectividad durante tu aprendizaje.</h4>
              </Col>


            </Row>



            <Row className="mb-4 mt-5">
              <Col>
                <Accordion defaultActiveKey="0" >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Cursos disponibles</Accordion.Header>
                    <Accordion.Body>


                      {/* <Row className="justify-content-end">
                    <Col className="col-auto">
                      <Button onClick={handlePagar} className="btn btn-success btn-lg" style={{ fontSize: '1rem' }}>Obtener más cursos <FontAwesomeIcon icon={faPlus} size="lg" /></Button>
                    </Col>
                  </Row> */}
                      <ListadoCursosLecturaVeloz
                        usuarioConConvenio={usuarioConConvenio}
                        folioContrato={folioContrato}
                        handleChangeComponent={handleChangeComponent}
                        showScrollButton={showScrollButton}
                        semanaAvance={semanaAvance}
                        diagnosticoHabilitado={diagnosticoHabilitado}
                      />


                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Col>
            </Row>

            {(!usuarioConConvenio && nombreLicencia !== 'Lectura Inteligente - UVEG') ? (
              <>
                <Row className="justify-content-center mt-3 mb-5">
                  <Col className="col-auto text-center">
                    <h2>¿Quieres acceder a todos nuestros cursos?</h2>
                    <h3>Conoce Click+ y descubre todo lo que tiene para ti</h3>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    {/* <div className="embed-responsive embed-responsive-16by9 mt-5 pt-1">
                  <iframe
                    title="Video Demostración"
                    className="embed-responsive-item"
                    src=""
                    allowFullScreen
                  ></iframe>
                </div> */}
                    <video className="pt-4 h-100 w-100" controls>
                      <source src="https://globalclickmexico.com/src/click+.mp4" type="video/mp4" />
                    </video>
                  </Col>

                  <Col>
                    <div className="contenedor-mos lectura-veloz">
                      <div className="contenedor-carrusel">
                        <ReactCarousel
                          interval={3500}
                          showArrows={false}
                          showStatus={false}
                          showThumbs={false}
                          swipeable={true}
                          emulateTouch={true}
                          infiniteLoop={true}
                          autoPlay={false}
                        >
                          {slides.map((slide, key) => (
                            <div className="contenido-mos" key={key}>
                              {slide.image}

                              {slide.title}

                              {slide.subtitle}

                              {slide.control}
                            </div>
                          ))}
                        </ReactCarousel>
                      </div>
                    </div>
                  </Col>
                </Row>


                <h3 className="mt-5 text-center">
                  ¡Descubre el mundo de posibilidades que se abre ante ti con
                  nuestra Licencia Premium! <br /><br />¿Estás listo para
                  potenciar tu aprendizaje?
                </h3>


                <Accordion defaultActiveKey="0" className="mt-4" style={{ paddingBottom: '50px' }} >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header><b>Dale un vistazo</b></Accordion.Header>
                    <Accordion.Body>

                      <h4 className="mt-5">Obtén acceso ilimitado a este catálogo de cursos:</h4>
                      <Row>
                        <Col>
                          <Container fluid className="pt-4">
                            {/* <TitleDashboard title="Obtén acceso ilimitado a este catálogo de cursos" /> */}



                            <Row>
                              {cursos.map(
                                (curso, idx) =>
                                  curso.estatus === 1 && (
                                    <Col
                                      id={idx}
                                      className="col-9 col-sm-6 col-md-4 col-lg-4 "
                                    >
                                      <Card className=" card-predefinidas invitado mb-4">
                                        <picture width="100%" height="100%">
                                          <source
                                            srcSet={`${require(`@assets/images/portadas/${curso.portadaCurso}`)}`}
                                          />

                                          <img
                                            loading="lazy"
                                            className="img-fluid"
                                            src={`${require(`@assets/images/portadas/${curso.portadaCurso}`)}`} // Aquí va la URL de la imagen de fondo
                                            alt="Imagen de fondo"
                                          />
                                        </picture>
                                      </Card>
                                    </Col>
                                  )
                              )}
                            </Row>

                            <Row className="justify-content-center">
                              <Col className="col-auto">
                                <Button onClick={handlePagar} className="btn btn-primary btn-lg" style={{ fontSize: '2rem' }}>¡Quiero seguir aprendiendo!</Button>
                              </Col>
                            </Row>
                          </Container>
                        </Col>
                      </Row>


                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </>
            ) : null}





            {/* <Row>
					<Col>
						<TitleDashboard title="Conoce la Plataforma Click+ con este vídeo demostración" />

						<div className="embed-responsive embed-responsive-16by9 mt-5 pt-1">
							<iframe title="Video Demostración" className="embed-responsive-item" src="https://globalclickmexico.com/img/video_demo/click_plus.mp4" allowFullScreen></iframe>
						</div>
					</Col>
				</Row> */}
          </>
        )}

        
      </Container>
    </Animated>
  );
};

export default HomeLecturaVeloz;
